<template>
  <div>
    <div class="row m-0" style="margin-top: 50px !important;margin-right:  -12px !important;margin-left:  -12px !important;">
      <div class="col-md-12 p-0" v-if="modelKySo.path">
        <PdfEditor :fileInfo="modelKySo" :pdf="`${modelKySo.path}`" />
      </div>
    </div>
  </div>
</template>

<script>

import appConfig from "@/app.config.json";
import {notifyModel} from "@/models/notifyModel";
import PdfEditor from "@/components/pdfEditor/PdfEditor";

export default {
  name: "thietLapKySo",
  page: {
    title: "Ký số",
    meta: [{name: "description", content: appConfig.description}],
  },
  components:{
    PdfEditor,
  },
  async created() {
    this.vanBanDiId = this.$route.params.id;
    await this.getVanBanDiById(this.$route.params.id);
  },
  computed:{
  },
  data() {
    return {
      title: "Ký số",
      apiUrl: process.env.VUE_APP_API_URL,
      apiViewFile: process.env.VUE_APP_API_URL + 'files/view/',
      files: null,
      showModalClock: true,
      vanBanDiId: null,
      modelKySo: {
        fileName: null,
        path: null,
        vanBanDiId: null
      }
    };
  },
  methods:{
   async getVanBanDiById(id){
      await this.$store.dispatch("vanBanDiStore/getById", id).then((res) => {
        if (res.resultCode == "SUCCESS") {
           this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage({resultString: "Tải văn bản thành công", resultCode: res.resultCode}));
          this.modelKySo.vanBanDiId = res.data.id;
          if (res.data.filePDF) {
            this.modelKySo.fileName = res.data.filePDF[0].fileName;
            this.modelKySo.path = this.apiViewFile + res.data.filePDF[0].fileId;
          } else if (res.data.file) {
            this.modelKySo.fileName = res.data.file[0].fileName;
            this.modelKySo.path = this.apiViewFile + res.data.file[0].fileId;
          }

          // if (value) {
          //   this.showModalThietLapKySoPhapLy = true;
          //   localStorage.setItem("kysophaply", JSON.stringify(this.modelKySo));
          // } else {
          //   this.showModalKySoPhapLy = true;
          //   this.modelKySo.userName = CURRENT_USER.USER_KY_SO.userNameKySo;
          //   this.modelKySo.password = CURRENT_USER.USER_KY_SO.userNameKySo;
          // }
        } else {
           this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    }
  }
}
</script>

<style scoped>

</style>